module.exports = __webpack_public_path__ + "static/media/csv-icon512x512.644d1f7b.png";